// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
//

import localizer from 'share/localization/Izenda.Localizer';

export default {
  TEXT_INPUT_TYPE: 'text',
  PASSWORD_INPUT_TYPE: 'password',
  DATA_SERVER_TYPE_VALUE: 'dataServerTypeValue',
  DATABASE_NAME: 'databaseName',
  CONNECTION_STRING: 'connectionString',
  CONNECTION_STRING_INPUT_TYPE: 'connectionStringInputType',
  CONNECTION_STRING_STATUS: 'connectionStringStatus',
  IS_DISABLED: 'isDisabled',

  QUERY_SOURCE_TYPE: {
    TABLE: 'Table',
    VIEW: 'View',
    STOREPROCEDURE: 'Stored Procedure',
    FUNCTION: 'Function'
  },

  get UNKNOWN_STATUS() {
    return localizer.getText('CONNECTION_UNKNOWN_STATUS');
  },
  get VALID_STATUS() {
    return localizer.getText('CONNECTION_VALID_STATUS');
  },
  get INVALID_STATUS() {
    return localizer.getText('CONNECTION_INVALID_STATUS');
  },

  get DATA_SOURCE_CHANGES() {
    return localizer.getText('CONNECTION_DATA_SOURCE_CHANGES');
  },
  get DELETED_DATA_SOURCE() {
    return localizer.getText('CONNECTION_DELETED_DATA_SOURCE');
  },
  get NEW_DATA_SOURCE() {
    return localizer.getText('CONNECTION_NEW_DATA_SOURCE');
  },

  get GUIDE_CONTENT() {
    return localizer.getText('CONNECTION_GUIDE_CONTENT');
  },

  DATABASE_NAME_MAX_LENGTH: 150,

  EXCEL_FILE_EXTENSIONS: ['.xlsx'],

  get DATABASE_NAME_CONSTRAINT() {
    return {
      presence: {
        presence: true,
        message: localizer.getText('CONNECTION_REQUIRE_DATABASE_NAME')
      },
      length: {
        maximum: 150,
        message: localizer.getText('CONNECTION_MAX_LENGTH_DATABASE_NAME')
      }
    };
  },

  get CONNECTION_STRING_CONSTRAINT() {
    return {
      presence: {
        presence: true,
        message: localizer.getText('CONNECTION_REQUIRE_CONNECTION_STRING')
      }
    };
  },

  get CONNECT_TYPE() {
    return {
      RECONNECT: localizer.getText('CONNECTION_TYPE_RECONNECT'),
      CONNECT: localizer.getText('CONNECTION_TYPE_CONNECT')
    };
  },

  DETECTED_CHANGE_LEVEL: {
    NONE: 0,
    ADDED: 1,
    MODIFIED: 2,
    DELETED: 3
  },

  APPROVAL_LEVEL: {
    PENDING: 0,
    QUERY_SOURCE: 1,
    QUERY_SOURCE_FIELD: 2
  },

  EMPTY_GUID: '00000000-0000-0000-0000-000000000000',

  CONNECTION_STRING_HASH:
    '************************************************************************************************************',

  get DELETE_MESSAGE() {
    return localizer.getText('CONNECTION_DELETE_MESSAGE');
  },
  get OVERRIDE_EXCEL_MESSAGE() {
    return localizer.getText('CONNECTION_OVERRIDE_EXCEL_MESSAGE');
  },
  get INVISIBLE_MESSAGE() {
    return localizer.getText('CONNECTION_INVISIBLE_MESSAGE');
  },
  get VISIBLE_MESSAGE() {
    return localizer.getText('CONNECTION_VISIBLE_MESSAGE');
  },
  get M03() {
    return localizer.getText('CONNECTION_DELETED_DATASOURCE_MESSAGE');
  },
  get M05() {
    return localizer.getText('CONNECTION_OVERRIDE_MESSAGE');
  },

  get MISMATCH_CONNECIONSTRING_DATASOURCE() {
    return localizer.getText('CONNECTION_MISMATCH_CONNECIONSTRING_DATASOURCE');
  },
  get NEW_CONNECTIONSTRING_DIFFERENT_SCHEMA() {
    return localizer.getText('CONNECTION_NEW_CONNECTIONSTRING_DIFFERENT_SCHEMA');
  },

  get GUIDECONTENT() {
    return localizer.getText('CONNECTION_GUIDECONTENT');
  },

  SERVER_TYPE: {
    MSSQL: '572bd576-8c92-4901-ab2a-b16e38144813'
  },
  get REVERSE_CONNECTION_STRING() {
    return localizer.getText('CONNECTION_REVERSE_CONNECTION_STRING');
  },

  get CONNECTION_STRING_INVALID() {
    return localizer.getText('CONNECTION_REQUIRE_CONNECTION_STRING');
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ConnectionConstants.js